// extracted by mini-css-extract-plugin
module.exports = {"container":"MenuBar_container__2reVn"};